import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import ConfirmModal from '../../components/Modal/ConfirmModal';

export default function RewardCard({
  merchant,
  title,
  description,
  code,
  validUntil,
  status,
}) {
  const isRedeemable = status === 'Active';
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="border rounded-xl shadow-sm p-4 space-y-3 relative">
        <div className="flex justify-center">
          <img src="/nextloop-logo.png" alt="Logo" className="h-12" />
        </div>

        <div className="text-center">
          <h2 className="font-semibold">{title}</h2>
          <p className="text-sm text-gray-600">{description}</p>
        </div>

        <div className="border-t border-b py-2 text-sm text-gray-700 space-y-1">
          <div className="flex justify-between">
            <span>Merchant</span>
            <span>{merchant}</span>
          </div>
          <div className="flex justify-between">
            <span>Voucher Code</span>
            <span>{code}</span>
          </div>
          <div className="flex justify-between">
            <span>Valid Until</span>
            <span>{validUntil}</span>
          </div>
          <div className="flex justify-between">
            <span>Terms apply</span>
            <span>Limit to 1 per pax</span>
          </div>
        </div>

        {isRedeemable && (
          <div className="flex justify-center mt-2">
            <QRCodeCanvas value={merchant + title + code} size={128} />
          </div>
        )}

        <div className="pt-2">
          <button
            disabled={!isRedeemable}
            onClick={() => isRedeemable && setShowModal(true)}
            className={`w-full py-2 rounded-lg text-white font-semibold ${
              isRedeemable
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            {status === 'Used' ? 'Used' : status === 'Expired' ? 'Expired' : 'Redeem'}
          </button>
        </div>
      </div>

      {showModal && (
        <ConfirmModal
        confirmTitle = "Confirm Redemption"
        confirmSubtitle = "Are you sure you want to redeem this reward?"
          onClose={() => setShowModal(false)}
          onConfirm={() => {
            alert('Voucher redeemed!'); // replace with actual logic
            setShowModal(false);
          }}
        />
      )}
    </>
  );
}
